var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMenuReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8664_5376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2919 4.71429H7.33272C6.81311 4.71429 6.31478 4.92877 5.94737 5.31054C5.57995 5.69231 5.37354 6.2101 5.37354 6.75001V18.9643C5.37354 19.5042 5.57995 20.022 5.94737 20.4038C6.31478 20.7855 6.81311 21 7.33272 21H17.1286C17.6482 21 18.1466 20.7855 18.514 20.4038C18.8814 20.022 19.0878 19.5042 19.0878 18.9643V6.75001C19.0878 6.2101 18.8814 5.69231 18.514 5.31054C18.1466 4.92877 17.6482 4.71429 17.1286 4.71429H15.1695",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2919 4.71429H7.33272C6.81311 4.71429 6.31478 4.92877 5.94737 5.31054C5.57995 5.69231 5.37354 6.2101 5.37354 6.75001V18.9643C5.37354 19.5042 5.57995 20.022 5.94737 20.4038C6.31478 20.7855 6.81311 21 7.33272 21H17.1286C17.6482 21 18.1466 20.7855 18.514 20.4038C18.8814 20.022 19.0878 19.5042 19.0878 18.9643V6.75001C19.0878 6.2101 18.8814 5.69231 18.514 5.31054C18.1466 4.92877 17.6482 4.71429 17.1286 4.71429H15.1695",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65967 4.71429C9.65967 4.25963 9.84028 3.82359 10.1618 3.5021C10.4833 3.18061 10.9193 3 11.374 3H13.0882C13.5429 3 13.9789 3.18061 14.3004 3.5021C14.6219 3.82359 14.8025 4.25963 14.8025 4.71429C14.8025 5.16894 14.6219 5.60498 14.3004 5.92647C13.9789 6.24796 13.5429 6.42857 13.0882 6.42857H11.374C10.9193 6.42857 10.4833 6.24796 10.1618 5.92647C9.84028 5.60498 9.65967 5.16894 9.65967 4.71429Z",
    fill: "white",
    stroke: "#525D71",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80225 16.7143V10.7143",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6597 16.7143V13.2857",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.231 16.7143V15",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8664_5376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.230957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuReports);
export default __webpack_public_path__ + "static/media/ic-menu-reports.e623c29470861039afe5283e1654e52a.svg";
export { ForwardRef as ReactComponent };